import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { BASEURL } from "../../constant/Url.js";
import Loading from "../common/Loading.jsx";
import hidePwdImg from "./hide-password.svg";
import showPwdImg from "./show-password.svg";

function LoginForm() {
  const navigate = useNavigate();
  const [passwordShown, setPasswordShown] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const login = async (data) => {
    try {
      setLoading(true);
      const res = await axios.post(`${BASEURL}/auth/local/login`, data);
      // if (res.data?.user?.role.slug === "agent") {
      //   setError("Something went wrong");
      //   return;
      // }
      localStorage.setItem("token", res.data.access_token);
      const token = localStorage.getItem("token");
      // <Tooltip title={record?.description}>
      //   {record?.description.slice(0, 100)}
      // </Tooltip>;

      if (token) {
        // navigate("/dashboard");
        window.location.reload(); // force a refresh w/ the server
      }
    } catch (error) {
      const errorMessage = error.response.data.message;
      console.log(error);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(login)}>
        <input
          type="email"
          name="identifier"
          id="email"
          placeholder="Email Address"
          {...register("identifier", { required: true })}
        />
        {errors.identifier?.type === "required" && (
          <span style={{ color: "red" }}> This field is required</span>
        )}

        <div style={{ position: "relative" }}>
          <input
            type={passwordShown ? "text" : "password"}
            name="password"
            id="password"
            placeholder="Password"
            {...register("password", { required: true, minLength: 6 })}
          />
          {errors.password?.type === "required" && (
            <span style={{ color: "red" }}>This field is required</span>
          )}
          <img
            src={passwordShown ? hidePwdImg : showPwdImg}
            onClick={() => setPasswordShown((prevState) => !prevState)}
            alt="password"
            className="passEye"
          />

          <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>
        </div>
        <button type="submit" className="login-button">
          {loading ? <Loading isSmall /> : "Login"}
        </button>
        <a
          style={{
            display: "flex",
            justifyContent: "center",
          }}
          rel="stylesheet"
          href="/forget-password"
        >
          Forget Password
        </a>
      </form>


      
    </div>
  );
}

export default LoginForm;
